import backendURLs from '~/misc/backendURLs';

export default (axios, id, params) => {
  return axios
    .get(`${backendURLs.shippingMethods}/${id}`, { params })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));
};
